import { FC } from 'react'
import { Box, BoxProps, CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`

export const Loader: FC<BoxProps> = (props) => {
  return (
    <StyledBox {...props}>
      <CircularProgress />
    </StyledBox>
  )
}
